module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    staticClass: "form-control",
    attrs: {
      "clearable": true,
      "placeholder": "Selectionnez un commercial"
    },
    model: {
      value: (_vm.user_id),
      callback: function($$v) {
        _vm.user_id = $$v
      },
      expression: "user_id"
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('el-option', {
      key: user.id,
      attrs: {
        "label": user.name,
        "value": user.id
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-674b0157"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Entities/Selects/UserSelect.vue
// module id = 705
// module chunks = 1